.buttonContainer {
  &,
  :global(.ant-btn-icon) div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
